export default __webpack_public_path__ + "static/media/logo-small.96954666.svg";